import { render, staticRenderFns } from "./SimpleLocation.vue?vue&type=template&id=0aae76f4"
import script from "./SimpleLocation.vue?vue&type=script&lang=js"
export * from "./SimpleLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports